<template>
  <div class="modal-window viewer bds063">
    <header class="modal-header">
      <div class="tit">
        <div class="left">
          <div class="file_name">{{ fileInfo.fileName }}</div>
          <div class="location">
            {{ fileInfo.groupName }} > {{ fileInfo.paperName }}
          </div>
        </div>
        <!-- 2020.12.08 / 김철환 / 일부 이미지 파일인 경우 기능 삭제 -->
        <div class="util" v-if="!imageFileExt.includes(fileInfo.fileExt)">
          <!-- 2020.09.24 / 김철환 / 산출물 파일(OUTPUT)은 편집하기 버튼 안보이도록 조건 추가 -->
          <!-- 2020.11.04 / 김철환 / IE에서 span 태그에 click 이벤트가 작동 안하는 현상 => 기존 span 태그를 div 태그로 변경하고 display:inline-block CSS 추가 -->
          <!-- 2020.11.04 / 김철환 / 산출물 파일은 편집이 안되므로 잠금설정 버튼 안보이도록 조건 추가 -->
          <div @click="editDoc(true)" style="display:inline-block">
            <button type="button" class="btn_eiidt"
              v-if="externalType == 'IN' &&
                    accessType == 'IN' &&
                    isEditableFile == true &&
                    fileInfo.fileType == 'SP' &&
                    fileInfo.locationKbn != 'OUTPUT' &&
                    fileVersionId == latestVersionInfo.fileVersionId &&
                    (authFlag == 'O' || authFlag == 'RW')"
              :disabled="fileLockYn == true && authFlag != 'O'"
              @click="editDoc(false)"
            >
              {{ $i18nUtil.trans("button.file.edit","파일 편집") }}
            </button>
          </div>
          <button type="button" class="btn-ver"
            v-if="isConvertibleFile == true"
            @click="versionHistory()"
          >
            {{ $i18nUtil.trans("message.fileViewer.currentVer","현재버전 {ver}", {ver: currentVersionInfo.versionName}) }}
          </button>
          <!-- 2020.12.07 / 김철환 / v2.0 파일 의견 아이콘 숨김 처리 -->
          <!-- <button type="button" class="ico-txt_opinion" 
            v-show="commentCnt == 0"
            @click="displayOpinion()"
          >
          </button>
          <button type="button" class="ico-txt_opinion"
            v-show="0 < commentCnt && commentCnt < 100"
            @click="displayOpinion()"
          >
            {{ commentCnt }}
          </button>
          <button type="button" class="ico-txt_opinion"
             v-show="commentCnt > 99"
            @click="displayOpinion()"
          >
            99+
          </button> -->
          <button type="button" class="btn_lock"
            v-show="externalType == 'IN' &&
                    accessType == 'IN' &&
                    isEditableFile == true &&
                    fileInfo.fileType == 'SP' &&
                    fileInfo.locationKbn != 'OUTPUT' &&
                    fileLockYn &&
                    authFlag == 'O'"
            @click="setLockFlag('toLockN')"
          >
            잠금
          </button>
          <button type="button" class="btn_lock active"
            v-show="externalType == 'IN' &&
                    accessType == 'IN' &&
                    isEditableFile == true &&
                    fileInfo.fileType == 'SP' &&
                    fileInfo.locationKbn != 'OUTPUT' &&
                    !fileLockYn && 
                    authFlag == 'O'"
            @click="setLockFlag('toLockY')"
          >
            잠금
          </button>
          <div class="droplayer icon more large right nosel relative" v-show="authFlag != ''">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on">더보기</v-btn>
              </template>
              <div class="dropdown-list">
                <div class="dropdown-list-item"
                  v-if="isConvertibleFile == true"
                >
                  <div class="tit">
                    <button type="button" @click="activityHistory()">{{ $i18nUtil.trans("button.activity.history","활동내역") }}</button>
                  </div>
                </div>
                <div class="dropdown-list-item">
                  <div class="tit">
                    <div @click="downloadFile(true)">
                      <button type="button" :disabled="!isInternalUser" @click="downloadFile(false)">{{ $i18nUtil.trans("button.file.download","다운로드") }}</button>
                    </div>
                  </div>
                </div>
                <!-- 내부망 && 쓰기 권한 있어야 다운 가능 -->
                <div class="dropdown-list-item">
                  <div class="tit">
                    <button type="button" @click="copyUrl()">{{ $i18nUtil.trans("button.url.copy","URL 복사") }}</button>
                  </div>
                </div>
                <div class="dropdown-list-item"
                  v-if="isConvertibleFile == true"
                >
                  <div class="tit">
                    <div @click="confirmRestoreFileVersion(false)">
                      <button type="button" :disabled="fileVersionId == latestVersionInfo.fileVersionId" @click="confirmRestoreFileVersion(true)">{{ $i18nUtil.trans("button.version.update","버전 업데이트") }}</button>
                    </div>
                  </div>
                </div>
                <div class="dropdown-list-item">
                  <div class="tit">
                    <button type="button" @click="confirmDeleteFile()">{{ $i18nUtil.trans("button.file.delete","파일 삭제") }}</button>
                  </div>
                </div>
              </div>
            </v-menu>
          </div>
        </div>
      </div>
      <button @click="closeViewer()" class="btn_close">닫기</button>
    </header>

    <div class="modal-content">
      <div class="viewer_box" :style="{ width: resizeWidth() + 'px' }">
        <v-row v-resize="onResize">
          <!-- [ Synap 파일 뷰어: excel 파일일 때 높이조절 ] -->
          <iframe
            :src="iframeUrl"
            style="width: 100%" :style="{ height: windowSize.heightXlsx + 'px' }"
            v-if="loading == false &&
                  isConvertibleFile == true &&
                  excelFileExt.includes(fileInfo.fileExt)"
          ></iframe>
          <!-- [ Synap 파일 뷰어: excel 외 파일일 때 높이조절 ] -->
          <iframe
            :src="iframeUrl"
            style="width: 100%" :style="{ height: windowSize.height + 'px' }"
            v-if="loading == false &&
                  isConvertibleFile == true &&
                  !excelFileExt.includes(fileInfo.fileExt)"
          ></iframe>
          <ViewerDefault
            v-if="loading == true"  
          ></ViewerDefault>
          <!-- [ Synap 파일 뷰어: MsOffice 파일이 아니며 이미지 파일인 경우 (psd, ai 파일 제외), 이미지 뷰어 노출 ] -->
          <!-- <ViewerImage
            v-if="loading == false &&
                  imageFileExt.includes(fileInfo.fileExt)"
            :fileInfo="fileInfo"
          ></ViewerImage> -->
          <!-- [ Synap 파일 뷰어: MsOffice 파일이 아니며 이미지 파일이 아닌 경우, 뷰어 영역 미노출 ] -->
          <ViewerBlock
            v-if="loading == false &&
                  isConvertibleFile == false &&
                  !imageFileExt.includes(fileInfo.fileExt)"
            :fileInfo="fileInfo"
          ></ViewerBlock>
        </v-row>
      </div>
      <!-- [ Synap 파일 뷰어 > 의견 창 영역 ] -->
      <!-- 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 -->
      <!-- <OpinionSearch
        ref="ViewerOpinion"
        @viewerOpinion="viewerOpinionClose()"
        @opinionChanged="getCommentCnt()"
        :itemInfo="initReqData"
      /> -->
      <!-- [ Synap 파일 뷰어 > 활동내역 창 영역 ] -->
      <ViewerActivityHistory
        ref="ViewerHistory"
        @viewerHistory="viewerHistoryClose()"
        @displayOtherVersion="displayOtherVersion"
        :itemInfo="initReqData"
        :fileInfo="fileInfo"
        :latestVersionInfo="latestVersionInfo"
        :currentVersionInfo="currentVersionInfo"
      />
      <!-- [ Synap 파일 뷰어 > 버전정보 창 영역 ] -->
      <ViewerVersionHistory
        ref="ViewerVersion"
        @viewerVersion="viewerVersionClose()"
        @displayOtherVersion="displayOtherVersion"
        @confirmRestoreFileVersion="confirmRestoreFileVersion"
        :itemInfo="initReqData"
      />
    </div>
    <!-- 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리로 modals-container에서 @deleteOpinion="deleteOpinion" 삭제 -->
    <modals-container
      @restoreFileVersion="restoreFileVersion"
      @deleteFile="deleteFile"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

import ViewerFrame from "./detail/ViewerFrame";
import ViewerBlock from "./detail/ViewerBlock";
import ViewerImage from "./detail/ViewerImage";
import ViewerDefault from "./detail/ViewerDefault";
// import OpinionSearch from "../opinion/OpinionSearch";  /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
import ViewerActivityHistory from "../activity/ViewerActivityHistoryByRegDate"; /* 2021.01.22 / 김철환 / 날짜별 조회하도록 수정한 컴포넌트 추가 */
import ViewerVersionHistory from "../version/ViewerVersionHistoryByRegDate"; /* 2021.01.22 / 김철환 / 날짜별 조회하도록 수정한 컴포넌트 추가 */
import ViewerNoticeModal from "../modal/ViewerNoticeModal";
import ViewerConfirmModal from "../modal/ViewerConfirmModal";
import { ViewerError } from "../error/ViewerError";

export default {
  components: {
    ViewerFrame,
    ViewerBlock,
    ViewerImage,
    ViewerDefault,
    // OpinionSearch,  /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
    ViewerActivityHistory,
    ViewerVersionHistory,
  },
  data() {
    return {
      authFlag: '',
      loading: true,
      fromPath: null,
      initReqData: {
        fileId: null,
        groupId: null,
		    fileVersionId: null,
		    sharepointSiteId: null,
		    sharepointFolderId: null,
		    sharepointFileId: null,
        type: "SINGLE",
        groupKbn: null,
        language: localStorage.getItem('defaultLanguage').substring(0, 2).toLowerCase() == 'ko' ? 'ko_KR' : 'en_US',
      },
      // parentLcation: '',
      fileInfo: {},
      // commentCnt: 0,  /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
      iframeUrl: null,
      fileVersionId: "",
      versionList: [],
      latestVersionInfo: {},
      currentVersionInfo: {},
      fileLockYn: false,
      externalType: "",
      accessType: "",
      isConvertibleFile: false,
      isEditableFile: false,
      isInternalUser: false,
      // isMsOffice: true,
      windowSize: {
        totalWidth: 0,
        width: 0,
        height: 0,
        heightXlsx: 0,
      },
      // toggleOpinion: true, /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
      toggleHistory: false,
      toggleVersion: false,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      excelFileExt: ["xls", "xlsx", "xlsb", "xlsm", "xlt", "xltm", "csv"], // Excel 파일 확장자
      imageFileExt: ["bmp", "gif", "jpg", "jpeg", "png", "tiff", "tif"], // 이미지 뷰어로 띄워줄 이미지 파일 확장자
    };
  },
  async created() {
    let obj = this;
    await obj.initSetIds();
	  obj.getFileInfo();
  },
  methods: {
    // 공통 AXIOS 호출하여 통신 (restAction.js)
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    /* 2020.10.30 / 김철환 / 알림 모달 추가 */
    ...mapActions("modals", ["showModal"]),
    /* 2020.11.03 / 김철환 / 토스트 알림 추가 */
    ...mapActions("modals", ["showToast"]),

    // 초기 데이터 setting
    initSetIds() {
      this.initReqData.fileId = this.$route.params.fileId; // 협업 fileId
      this.initReqData.groupId = this.$route.params.groupId; // 공간 ID
      this.initReqData.sharepointSiteId = this.$route.params.spSiteId;
      this.initReqData.sharepointFolderId = this.$route.params.spFolderId;
      this.initReqData.sharepointFileId = this.$route.params.spFileId; // 쉐어포인트 fileid
    },

    // 파일 정보 조회
    getFileInfo() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/viewer/getImgKey",
        method: "post",
        req: obj.initReqData,
      };
      obj.showLoadingbar(); // 프로그레스바 시작 
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          obj.hideLoadingbar(); // 프로그레스바 종료
          
          let errorCode = res.errorCode;
          if(errorCode == null) {
            obj.loading = false;

            obj.authFlag = res.fncAuthRst.authFlag; // 권한 구분
            let info = res.result.fileInfo; // file 정보
            if(info != null) {
              if(info.groupKbn === 'CFRC') {
                info.groupName = obj.$i18nUtil.trans("entity.cogroup.groupKbn.cfrc", "회의/협의")
              }else if(info.groupKbn === 'SHAR') {
                info.groupName = obj.$i18nUtil.trans("entity.cogroup.groupKbn.shar", "정보공유")
              }else if(info.groupKbn === 'USER') {
                info.groupName = obj.$i18nUtil.trans("entity.cogroup.groupKbn.user", "프라이빗")
              }
            }
            obj.fileInfo = info;
            localStorage.setItem('customParamViewer', res.result.fileInfo.fileId) // synap 파일뷰어 권한 설정 위해 추가
            obj.fileLockYn = res.result.fileInfo.lockYn == "N" ? false : true; // 파일 잠금 여부 (Y: 잠금O/N:잠금X)
            // obj.docGrade = res.result.fileInfo.docGrade == "NORMAL" ? "PUBLIC" : "PRIVATE"; // NORMAL(공개), RESTRICT/SECRET(비공개)
            obj.iframeUrl = $(location).attr("origin") + res.result.iframeUrl; // MSOffice 파일 뷰어 제공 시, url
            obj.fileVersionId = res.result.fileVersionId; // file 버전 ID
            obj.externalType = res.result.externalType; // 서비스 구분 (IN: 내부서비스 / OUT: 외부서비스)
            obj.accessType = res.result.accessType; // 접속 위치 구분 (IN: 내부망 / OUT: 외부망)
            obj.isConvertibleFile = res.result.isConvertibleFile; // 이미지 변환 파일 여부
            obj.isEditableFile = res.result.isEditableFile; // 편집 가능 파일 여부
            obj.isInternalUser = res.result.isInternalUser; // 내부사용자 여부 (true: 임직원 / false: 그룹사 및 외부협력사 직원)
            // obj.checkFileExt(obj.fileInfo); // File 확장자 체크하여 뷰어 제공 여부 결정
            if(obj.initReqData.fileId == null) {
              obj.initReqData.fileId = res.result.fileInfo.fileId // sharepoint url로 접근 시, fileId가 없어 넣어줌
            }
            obj.initReqData.groupKbn = res.result.fileInfo.groupKbn; // 다운로드 API 요청 파라미터 추가
            /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
            // obj.$refs.ViewerOpinion.setFileVersionId(obj.fileVersionId); // 의견창에 fileVersion 넘겨줌
            // obj.getCommentCnt();
            // obj.$refs.ViewerOpinion.opinionInit(obj.initReqData);
            obj.getFileVersionInfo(); // 파일 버전 정보 및 버전 리스트 호출
            obj.$refs.ViewerHistory.getFileActivityHistoryRegDateList(); // 파일 활동내역 조회 (파일 버전 정보 Insert 이후 시점에 호출해야)
          } else {
            if(errorCode == "COFILE_COGROUP_CLOSED") { 
              obj.toastInfo.message = obj.$i18nUtil.trans("TB017"); // 접근권한이 없습니다. 홈 화면으로 이동합니다.
              obj.showToast(obj.toastInfo);
              obj.$router.replace("/general/home");
            }
          }
        })
        .catch(function (err) {
          obj.hideLoadingbar(); // 프로그레스바 종료
          console.log(err);
        });
    },

    // 파일 버전 조회 (현 파일 버전정보, 최신 버전정보, 버전 리스트)
    getFileVersionInfo() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/cofile/getFileVersionList",
        method: "post",
        req: obj.initReqData,
      };
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          let errorCode = res.errorCode;
          if (errorCode == null) {
            obj.versionList = res.result.versionList; // 해당 파일의 버전 리스트
            obj.latestVersionInfo = res.result.latestVersionInfo; // file 최신 버전 정보
            obj.currentVersionInfo = res.result.currentVersionInfo; // 현재 파일의 버전 정보
            obj.$refs.ViewerVersion.initVersion(res.result, obj.initReqData);
          } else if (errorCode != null) {
            ViewerError(errorCode);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    // 파일에 대한 의견 수 조회
    /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
    /*getCommentCnt() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/opinion/commentCount",
        method: "post",
        req: obj.initReqData,
      };
      obj.ASYNC_COWORK_REST_ACTION(reqData).then(function (res) {
        let errorCode = res.errorCode;
        if (errorCode == null) {
          obj.commentCnt = res.result;
        } else if (errorCode != null) {
          ViewerError.viewerError(errorCode);
        }
      });
    },*/

    // MSOffice 파일은 파일 뷰어 제공 -- 그 외 파일명만 보여줌
    /*checkFileExt(data) {
      let obj = this;
      let ext = data.fileExt;

      if (
        ext == "xlsx" ||
        ext == "xls" ||
        ext == "pdf" ||
        ext == "docx" ||
        ext == "doc" ||
        ext == "pptx" ||
        ext == "ppt" ||
        ext == "txt" ||
        ext == "hwp"
      ) {
        obj.isMsOffice = true;
      } else {
        obj.isMsOffice = false;
      }
    },*/

    // 편집하기 버튼 활성/비활성 CSS
    /*editDocBtnCss() {
      if(this.fileLockYn == true && this.fileOwnerYn == 'N') {
   		  // 잠금상태O && 소유자 아닐 때 , class + active
        return 'active';
      } else if(this.fileLockYn == false && this.fileOwnerYn == 'N') {
        // 잠금상태X && 소유자 아닐 때 , class  + ''
        return '';
      }
    },*/

    /*
     * 편집하기
     * 내부서비스                     externalType == 'IN'
     * 내부망                         accessType == 'IN'
     * 최신 버전만 편집 가능           fileVersionId == latestVersionInfo.fileVersionId
     * DOCX/PPTX 확장자               isEditableFile == true
     * 쉐어포인트에 저장된 파일         fileType == 'SP'
     * 최종산출물(OUTPUT)파일 편집 불가 locationKbn != 'OUTPUT'
     * 잠금 상태 시 소유자만 편집 가능  fileLockYn == true && authFlag == 'O'
     * 잠금 상태 해제 시 쓰기 권한 필요 fileLockYn == false && (authFlag == 'O' || authFlag == 'RW')
     */
    editDoc(isDisabled) {
      if (this.externalType == "IN" && this.accessType == "IN" && this.isEditableFile && this.authFlag == "O") {
        if(!isDisabled) {
          let url = this.fileInfo.owaUrl;
          url += "&domain=" + encodeURIComponent(location.protocol + '//' + location.host);
          console.log(url);
          window.open(url);
        }
      } else if (this.externalType == "IN" && this.accessType == "IN" && this.isEditableFile && this.authFlag == "RW") {
        if (this.fileLockYn == true) {
          // 잠금상태O && 소유자 아닐 때
          let modalInfo = {
            name: "viewerNoticeModal",
            width: "400px",
            obj: this.$modal,
            title: this.$i18nUtil.trans("title.dialog.notice","알림"),
            contents: this.$i18nUtil.trans("AB009"), // 문서 소유자에 의해 문서가 현재 잠금상태로 편집이 불가합니다.
            component: ViewerNoticeModal
          };
          this.showModal(modalInfo);
        } else if (this.fileLockYn == false) {
          if(!isDisabled) {
            // 잠금상태X && 소유자 아닐 때
            let url = this.fileInfo.owaUrl;
            url += "&domain=" + encodeURIComponent(location.protocol + '//' + location.host);
            console.log(url);
            window.open(url);
          }
        }
      }
    },

    // 버전정보 창 오픈
    versionHistory() {
      this.toggleVersion = !this.toggleVersion;
      if (this.toggleHistory && this.toggleVersion) {
        this.activityHistory();
      }

      document.getElementById("ViewerVersion").classList.toggle("active");
    },

    // 의견 창 (우측)
    /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
    /*displayOpinion() {
      this.toggleOpinion = !this.toggleOpinion;
      if (this.toggleHistory && this.toggleOpinion) {
        this.activityHistory();
      }
      if (this.toggleVersion && this.toggleOpinion) {
        this.versionHistory();
      }

      document.getElementById("viewerPaperAllComment").classList.toggle("active");
    },*/

    // 활동내역 창 오픈
    activityHistory() {
      this.etcMoreClose();
      this.toggleHistory = !this.toggleHistory;
      if (this.toggleVersion && this.toggleHistory) {
        this.versionHistory();
      }
      
      document.getElementById("viewerHistory").classList.toggle("active");
    },

    // 버전별 파일 다운로드
    // 필수값: fileID, groupId, fileVersionId, SINGLE(단일파일)
    // 버전 ID 없을 시, 최신 버전 다운로드
    downloadFile(isDisabled) {
      let obj = this;
      let isInternalUser = obj.isInternalUser;
      obj.etcMoreClose();

      // 외부사용자 다운로드 요청 시
      if(!isInternalUser) {
        let modalInfo = {
          name: "viewerNoticeModal",
          width: "400px",
          obj: this.$modal,
          title: this.$i18nUtil.trans("title.dialog.notice","알림"),
          contents: this.$i18nUtil.trans("AB011"), // 파일의 다운로드 권한을 확인해주세요.
          component: ViewerNoticeModal
        };
        obj.showModal(modalInfo);
      } else {
        if(!isDisabled) {
          if(obj.authFlag == "O" || obj.authFlag == "RW") {
            obj.initReqData.fileVersionId = obj.currentVersionInfo.fileVersionId;
            // 프로그레스바 시작
            obj.showLoadingbar();
            obj.$axios({
              url: "/api/cofile/cofile/download",
              responseType: "blob",
              headers: {
                "Content-Type": "application/json",
              },
              method: "post",
              data: obj.initReqData,
            })
            .then((res) => {
              //프로그레스바 종료 
              obj.hideLoadingbar();
              try {
                let fileName = obj.fileInfo.fileName;
                let blob = new Blob([res.data], {
                  type: res.headers["content-type"],
                });

                // 에러코드 체크
                if(res.data.type.startsWith("application/json")) {
                  let errorCode = obj.blobToString(blob);
                  if(errorCode == "NOT_AUTHORIZED") {
                    obj.toastInfo.message = obj.$i18nUtil.trans("TB044");
                    obj.showToast(obj.toastInfo);
                    return;
                  } else if(errorCode == "COFILE_FILE_DOWNLOAD_DENIED_FROM_EXTERNAL") {
                    let modalInfo = {
                      name: "viewerNoticeModal",
                      width: "400px",
                      obj: this.$modal,
                      title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                      contents: this.$i18nUtil.trans("AB101"), // 외부망에서는 파일 다운로드를 할 수 없습니다.
                      component: ViewerNoticeModal
                    };
                    obj.showModal(modalInfo);
                    return;
                  } else {
                    let modalInfo = {
                      name: "viewerNoticeModal",
                      width: "400px",
                      obj: this.$modal,
                      title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                      contents: this.$i18nUtil.trans("AB077"), // 알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요.
                      component: ViewerNoticeModal
                    };
                    obj.showModal(modalInfo);
                    return;
                  }
                }

                if (window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                  let link = document.createElement("a");
                  link.target = "_self";
                  link.setAttribute("download", fileName);
                  link.href = window.URL.createObjectURL(blob);
                  link.click();
                  link.remove();
                }
                obj.toastInfo.message = obj.$i18nUtil.trans("TB008"); // 다운로드가 완료되었습니다.
                obj.showToast(this.toastInfo);
              } catch (e) {
                let modalInfo = {
                  name: "viewerNoticeModal",
                  width: "400px",
                  obj: this.$modal,
                  title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                  contents: this.$i18nUtil.trans("AB077"), // 알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요.
                  component: ViewerNoticeModal
                };
                obj.showModal(modalInfo);
                console.error(e);
              }
            })
            .catch((res) => {
              //프로그레스바 종료 
              obj.hideLoadingbar();
              let modalInfo = {
                  name: "viewerNoticeModal",
                  width: "400px",
                  obj: this.$modal,
                  title: this.$i18nUtil.trans("title.dialog.notice","알림"),
                  contents: this.$i18nUtil.trans("AB077"), // 알 수 없는 이유로 다운로드에 실패했습니다. 일반적으로 이 문제는 통신오류 등에 의해 발생합니다. 잠시 후 다시 시도해 주시거나 동일한 오류가 계속 발생하는 경우, 시스템 담당자에게 문의해 주세요.
                  component: ViewerNoticeModal
                };
                obj.showModal(modalInfo);
              // status 200이 아닌경우에도 콜백호출 (프로젝트에 맞게 수정필요)
              console.log(res);
            });
          } else {
            let modalInfo = {
              name: "viewerNoticeModal",
              width: "400px",
              obj: this.$modal,
              title: this.$i18nUtil.trans("title.dialog.notice","알림"),
              contents: this.$i18nUtil.trans("AB011"), // 파일의 다운로드 권한을 확인해주세요.
              component: ViewerNoticeModal
            };
            obj.showModal(modalInfo);
          }
        }
      }
    },

    // 파일 삭제 확인
    confirmDeleteFile() {
      let obj = this;
      obj.etcMoreClose();

      if(obj.authFlag == "O") {
        let modalInfo = {
          name: "deleteFile",
          width: "400px",
          obj: this.$modal,
          title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
          contents: obj.$i18nUtil.trans("AB013"), // 파일을 삭제하시겠습니까?
          btnName: obj.$i18nUtil.trans("button.delete","삭제"),
          reqData: obj.initReqData,
          component: ViewerConfirmModal
        };
        obj.showModal(modalInfo);
      } else { // 로그인한 사용자가 삭제권한이 없는 경우
        obj.toastInfo.message = obj.$i18nUtil.trans("TB056"); // 삭제 권한이 없습니다.
        obj.showToast(obj.toastInfo);
      }
    },

    // 파일 삭제 
    // 삭제 후 closeViewer 함수 호출
    deleteFile(_data) {
      let obj = this;
      let reqData = {
        url: "/api/cofile/paper/deleteAttach",
        method: "post",
        req: _data.reqData,
      };

      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          let errorCode = res.errorCode;
          if (errorCode == null) {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB011"); // 파일이 삭제되었습니다.
            obj.showToast(obj.toastInfo);
            obj.closeViewer()
            // obj.$router.push('/general/board/'+obj.parentLcation);
          } else if (errorCode != null) {
            ViewerError(errorCode);
          }
        })
        .catch(function (err) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          console.log(err);
        });
    },

    // 버전 업데이트 확인
    confirmRestoreFileVersion(isLatestVersion) {
      let obj = this;
      obj.etcMoreClose();

      if (this.fileVersionId == this.latestVersionInfo.fileVersionId) {
        let modalInfo = {
          name: "viewerNoticeModal",
          width: "400px",
          obj: this.$modal,
          title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
          contents: obj.$i18nUtil.trans("AB012"), // 현재 파일이 최신버전으로 업데이트가 불가합니다.
          component: ViewerNoticeModal
        };
        obj.showModal(modalInfo);
      } else if(obj.fileLockYn == true) {
        let modalInfo = {
          name: "viewerNoticeModal",
          width: "400px",
          obj: this.$modal,
          title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
          contents: obj.$i18nUtil.trans("message.Viewer.001","잠금 상태에서는 업데이트가 불가합니다."),
          component: ViewerNoticeModal
        };
        obj.showModal(modalInfo);
      } else if (this.fileVersionId != this.latestVersionInfo.fileVersionId) {
        if(!isLatestVersion) {
          if(obj.authFlag == "O" || obj.authFlag == "RW") {
            let fileId = obj.initReqData.fileId; 
            let fileVersionId = obj.currentVersionInfo.fileVersionId;
            let modalInfo = {
              name: "restoreFileVersion",
              width: "400px",
              obj: this.$modal,
              title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
              contents: obj.$i18nUtil.trans("AB010"), // 선택한 버전으로 파일을 업데이트하시겠습니까? 해당 파일로 최신 버전으로 생성됩니다.
              btnName: obj.$i18nUtil.trans("button.update","업데이트"),
              fileId: fileId,
              fileVersionId: fileVersionId,
              component: ViewerConfirmModal
            };
            obj.showModal(modalInfo);
          } else { // 로그인한 사용자가 버전 업데이트 권한이 없는 경우
            let modalInfo = {
              name: "viewerNoticeModal",
              width: "400px",
              obj: this.$modal,
              title: obj.$i18nUtil.trans("title.dialog.notice","알림"),
              contents: obj.$i18nUtil.trans("TB044"), // "권한이 없습니다.", // 2020.10.30 메시지창 내역 파일에 정의된 내용이 없어서 임의로 설정. 변경 필요
              component: ViewerNoticeModal
            };
            obj.showModal(modalInfo);
          }
        }
      }
    },

    // 버전 업데이트
    // 업데이트 완료 후 getFileInfo 함수 호출
    restoreFileVersion(_data) {
      let obj = this;
      let reqData = {
        url: "/api/cofile/cofile/restoreFileVersion",
        method: "post",
        req: {
          fileId: _data.fileId,
          fileVersionId: _data.fileVersionId,
        }
      };

      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          let errorCode = res.errorCode;
          if (errorCode == null) {
            obj.toastInfo.message = obj.$i18nUtil.trans("TB009"); // 최신 파일로 복원이 완료되었습니다.
            obj.showToast(obj.toastInfo);
            obj.initReqData.fileVersionId = "";
            obj.getFileInfo();
          } else if (errorCode != null) {
            ViewerError(errorCode);
          }
        })
        .catch(function (err) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          console.log(err);
        });
    },

    // URL 복사
    copyUrl() {
      this.etcMoreClose();
      let url = window.location.href;
      let element = document.createElement("input");
      let s = element.style;
      s.border = "0";
      s.width = "1px";
      s.height = "1px";
      s.background = "#fff";
      s.color = "#fff";
      element.value = url;
      this.$el.appendChild(element);
      element.select();
      document.execCommand("copy");
      this.$el.removeChild(element);
      this.toastInfo.message = this.$i18nUtil.trans("TB010"); // URL이 복사되었습니다.
      this.showToast(this.toastInfo);
    },

    // 더보기 메뉴 팝업 닫기 CSS
    etcMoreClose() {
      $("#etcMorePop").attr("class", "");
    },

    // 의견 창 닫기
    /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
    /*viewerOpinionClose() {
      this.toggleOpinion = !this.toggleOpinion;
    },*/

    // 활동내역 창 닫기
    viewerHistoryClose() {
      this.toggleHistory = !this.toggleHistory;
    },
    
    // 버전정보 창 닫기
    viewerVersionClose() {
      this.toggleVersion = !this.toggleVersion;
    },

    // 잠금 설정/해제 CSS
    /*lockActive() {
      if (this.fileInfo.lockYn == "Y") {
        return "";
      } else if (this.fileInfo.lockYn == "N") {
        return "active";
      }
    },*/

    // 잠금 설정/해제
    setLockFlag(type) {
      let fileId = this.initReqData.fileId;
      let lockYn;

      if (type == "toLockY") {
        lockYn = "Y";
      } else if (type == "toLockN") {
        lockYn = "N";
      }

      let obj = this;
      let reqData = {
        url: "/api/cofile/cofile/setLockFlag",
        method: "post",
        req: {
          fileId: fileId,
          lockYn: lockYn,
        },
      };

      // 프로그레스바 시작
      obj.showLoadingbar();
      obj.ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          let errorCode = res.errorCode;
          if (errorCode == null) {
            if (res.result.lockYn == "Y") {
              obj.initReqData.fileVersionId = '';
              obj.fileLockYn = true;
              /* 2020.04.14 / 김철환 / 잠금설정 시 새로운 버전이 추가되어 이미지 변환 재호출 및 활동내역 목록 갱신 => 새로운 버전이 추가되지 않음 */
              obj.getFileInfo();
              obj.toastInfo.message = obj.$i18nUtil.trans("TB006"); // 잠금이 설정되었습니다.
              obj.showToast(obj.toastInfo);
            } else {
              obj.fileLockYn = false;
              /* 2020.04.14 / 김철환 / 잠금해제 시 새로운 버전이 추가되어 이미지 변환 재호출 및 활동내역 목록 갱신 */
              //obj.$refs.ViewerHistory.getFileActivityHistoryRegDateList();
              obj.getFileInfo();
              obj.toastInfo.message = obj.$i18nUtil.trans("TB007"); // 잠금이 해제되었습니다.
              obj.showToast(obj.toastInfo);
            }
          }
        })
        .catch(function (err) {
          //프로그레스바 종료 
          obj.hideLoadingbar();
          console.log(err);
        });
    },

    // synap뷰어 사이즈 조절
    onResize() {
      (this.windowSize.totalWidth = window.innerWidth),
        (this.windowSize.width = window.innerWidth - 340), // 우측 의견/활동영역 등 너비
        (this.windowSize.height = window.innerHeight - 54 - 24); // header 높이 - 하단 숨겨진 부분 높이
      this.windowSize.heightXlsx = window.innerHeight - 54 - 21; // header 높이 - xlsx 일 때 하단 메뉴 높이
    },

    // 우측 의견/활동영역 등 show/hide에 따른 synap뷰어 width 사이즈 조절
    /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리로 if문 조건에서 this.toggleOpinion 삭제 */
    resizeWidth() {
      if (this.toggleHistory || this.toggleVersion) {
        return this.windowSize.width;
      } else if (!this.toggleHistory && !this.toggleVersion) {
        return this.windowSize.totalWidth;
      }
      // return this.toggleOpinion ? this.windowSize.width : this.windowSize.totalWidth
    },

    // 문서 등급
    // 현재 등급: GET / CSS: CLASS / 등급 변경: SET
    /*docGradeEvent(docGrade, type) {
      // docGrade: PUBLIC / PRIVATE
      if (type == "get") {
        // 현재 문서 등급
        return docGrade == "PUBLIC" ? "공개" : "비공개";
      } else if (type == "class") {
        // 등급 토글 시, css active
        if (this.docGrade == "PUBLIC") {
          $("#setPublic").attr("class", "active");
          $("#setPrivate").attr("class", "");
        } else if (this.docGrade == "PRIVATE") {
          $("#setPublic").attr("class", "");
          $("#setPrivate").attr("class", "active");
        }
      } else if (type == "set") {
        // 문서 등급 변경

        $("#docGrade_close").attr("class", "");

        let setDocGrade;
        let fileId = this.initReqData.fileId;

        if (docGrade == "PUBLIC") {
          this.docGrade = "PUBLIC";
          this.docGradeEvent("PUBLIC", "get");
          $("#setPublic").attr("class", "active");
          $("#setPrivate").attr("class", "");
          setDocGrade = "NORMAL";
        } else if (docGrade == "PRIVATE") {
          this.docGrade = "PRIVATE";
          this.docGradeEvent("PRIVATE", "get");
          $("#setPublic").attr("class", "");
          $("#setPrivate").attr("class", "active");
          setDocGrade = "SECRET";
        }

        let obj = this;
        let reqData = {
          url: "/api/cofile/cofile/setDocGrade",
          method: "post",
          req: {
            fileId: fileId,
            docGrade: setDocGrade,
          },
        };
        obj
          .ASYNC_COWORK_REST_ACTION(reqData)
          .then(function (res) {
            let errorCode = res.errorCode;
            if (errorCode == null) {
              alert("문서 등급 변경이 완료되었습니다.");
            } else if (errorCode != null) {
              ViewerError.viewerError(errorCode);
            }
          })
          .catch(function (err) {
            console.log(err);
          });
      }
    },*/

    // 현재 버전 CSS
    /*currentVersionCss(ver) {
      if (this.fileVersionId == ver.fileVersionId) {
        return "active";
      }
    },*/

    // 파일의 다른 버전 보기
    displayOtherVersion(version) {
      let groupId = this.initReqData.groupId;
      let fileId = this.initReqData.fileId;
      let versionId = version.fileVersionId; // 현재 버전 정보

      if (versionId == this.latestVersionInfo.fileVersionId) {
        // 현재 버전 == 최신 버전
        this.initReqData.fileVersionId = "";
        this.getFileInfo();
      } else if (versionId != this.latestVersionInfo.fileVersionId) {
        // 현재 버전 != 최신 버전
        this.initReqData.fileVersionId = version.fileVersionId;
        this.getFileInfo();
      }

      //$("#version_close").attr("class", "");
    },

    // 의견, 답변 삭제
    /* 2020.12.07 / 김철환 / v2.0 파일의견 기능 숨김 처리 */
    /*deleteOpinion(_data) {
      let obj = this;
      let modalName = _data.name;
      let reqData = {
        url: "/api/cofile/opinion/deleteComment",
        method: "post",
        req: _data.item,
      };
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          let errorCode = res.errorCode;
          if(errorCode == null) {
            obj.$refs.ViewerOpinion.refresh();
            if(modalName = "deleteOpinion") {
              //obj.toastInfo.message = obj.$i18nUtil.trans(""); // 의견삭제 토스트알림
              //obj.showToast(obj.toastInfo);
            } else if(modalName = "deleteComment") {
              //obj.toastInfo.message = obj.$i18nUtil.trans(""); // 답변삭제 토스트알림
              //obj.showToast(obj.toastInfo);
            }
          } else if (errorCode != null) {

          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },*/
    /* blob To string */
    blobToString(blob) {
      let u, x;
      u = URL.createObjectURL(blob);
      x = new XMLHttpRequest();
      x.open('GET', u, false);
      x.send();
      URL.revokeObjectURL(u);
      return x.responseText;
    },
    // 뷰어 종료, 우측 상단
    closeViewer() {
      localStorage.removeItem('customParamViewer') // synap 파일뷰어 권한 설정 위해 추가
      window.open('', '_self', '');
      window.close();

      // url로 직접 입력으로 창을 open 한 경우, 크롬에서 창이 꺼지지 않아 추가
      // 크롬에서 url 직접 입력하여 파일뷰어 열었을 때 사용
      // IE에서 url 직접 입력하여 파일뷰어 오픈 > 닫기 버튼 > 창 닫겠습니까? > N 일 때 사용
      // this.$router.go(-1)
      
      // 보드에서 뒤로가기시 문제발생 주석처리 : 조성기 2021-07-13
      // index.js 에서 처리 ( 주석 해제 ) : 조성기 2021-07-14
      this.$router.push('/general/home')
      return false;
    }
  },
};
// synap config,js 썸네일 클릭 이벤트 받는 function
/*window.setThumbPage = function (data) {
  // var split = "thumb_area";
  var split = "thumb";
  var page = data.substring(split.length);
  var opinionPage = page * 1 + 1;
  var sendingData = document.getElementById("fpageNoX"); // 의견 component hidden value
  sendingData.value = opinionPage;
};*/
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/file/viewer/Viewer.vue